import React from 'react';
import { Legend } from '@bvt-features/tenant-suitability/components/Legend';
import { useMap } from 'react-leaflet';
import { useMainMap } from '@bvt-features/mainmap/mainmap/hook/useMainMap';
import { useLegend } from '@bvt-features/tenant-suitability/hooks/useLegend';

export const TSALegendContainer = () => {
  const initialMap = useMap();
  const mainMap = useMainMap();
  const legend = useLegend();

  if (legend.state.items.length === 0) {
    return null;
  }

  return (
    <Legend
      items={legend.state.items}
      onMouseEnter={() => {
        initialMap.scrollWheelZoom.disable();
        initialMap.doubleClickZoom.disable();
        initialMap.dragging.disable();
      }}
      onMouseLeave={() => {
        initialMap.scrollWheelZoom.enable();
        initialMap.doubleClickZoom.enable();
        initialMap.dragging.enable();
      }}
      style={{
        right: mainMap.state.activeMenu
          ? mainMap.state.activeMenuWidth + 8 + 'px'
          : '1rem',
      }}
    />
  );
};
